import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useApi } from '@axiom/ui';

import { EnvUtil } from '../../utils/env-util';
import { SubmissionsApi } from '../../api/submissions-api';

export type DigitalSubmissionRedirectorProps = {
  name?: string;
};

export const DigitalSubmissionRedirector = ({
  name = 'DIGITAL_SUBMISSION_REDIRECTOR',
}: DigitalSubmissionRedirectorProps = {}) => {
  const { submissionId } = useParams();
  const [{ data: submission } = { data: undefined }] = useApi(
    submissionId
      ? SubmissionsApi.readSubmissionDetails(submissionId)
      : undefined
  );
  useEffect(() => {
    if (submission?.accountId && submissionId) {
      window.location.assign(
        `${EnvUtil.clientUrl}/account/${submission.accountId}/submission/${submissionId}/matches`
      );
    }
  }, [submission, submissionId]);

  return <div data-test={name} />;
};
